<template>
  <div id="AddToHome">
    <div class="ios" v-show="iosAddShow">
      <div class="mask">

      </div>
      <div class="content">
        <img src="../../assets/icon/image_guide_00@2x.png" class="case">
        <h3>Do not want  to miss the discount?</h3>
        <div class="content-row">
          <p>Step 1: Tap the share button below</p><img src="../../assets/icon/image_guide_01@3x.png" alt="">
        </div>
        <div class="content-row">
          <p>Step 2: Choose “Add to Home Screen”</p><img src="../../assets/icon/image_guide_02@3x.png" alt="">
        </div>
      </div>
      <a>
        <img src="../../assets/icon/image_add_to_homescreen_finger@3x.png" alt="">
      </a>
      <i @click="hideAddHome">
        <img src="../../assets/icon/iamge_nav_cancel@3x.png" alt="">
      </i>
    </div>
    <div class="android" v-show="androidAddShow">

    </div>
  </div>
</template>



<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: String,
    loadingShow:{
      type:Boolean,
      default:false
    }
  },
  created () {

  },
  data () {
    return {
    }
  },
  methods:{
    hideAddHome(){
      this.$store.commit("updateAddHomeShow",{
        "addHome":false
      })
    }
  },
  watch: {

  },
  computed:{
    iosAddShow(){
      return this.$store.state.web_ios_addHome_show
    },
    androidAddShow(){
      return this.$store.state.web_android_addHome_show
    }
  },
  mounted(){
    console.log(this.$store.state.web_ios_addHome_show)
  }
}
</script>

<style lang="less" scoped>
@keyframes down-up {
  0%{
    transform: translate3d(-50%,0,0);
  }
  50%{
    transform: translate3d(-50%,20px,0);
  }
  100%{
    transform: translate3d(-50%,0,0);
  }
}
  #AddToHome{
    width: 100%;
    height: 100%;
    .mask{
      background: rgba(0,0,0,0.9);
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
    }
    a{
      display: block;
      width: 44px;
      height: 44px;
      position: fixed;
      left: 50%;
      bottom: 24px;
      z-index: 1002;
      transform: translate(-50%,0);
      animation: down-up 1.2s linear infinite;
      img{
        display: block;
        width: 44px;
        height: 44px;
      }
    }
    i{
      position: fixed;
      top: 20px;
      left: 20px;
      width: 44px;
      height: 44px;
      display: block;
      z-index: 1002;
      img{
        display: block;
        width: 22px;
        height: auto;
      }
    }
    .content{
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      height: auto;
      z-index: 1001;
      h3{
        text-align: center;
        font-size: 20px;
        color: rgb(255,189,31);
        margin-top: 26px;
      }
      .content-row{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        p{
          color: #FFF;
          font-size: 16px;
          margin-right: 8px;
          height: 16px;
          line-height: 16px;
        }
        img{
          display: block;
          width: auto;
          height: 20px;
        }
      }
      img{
        display: block;
      }
      .case{
        width: 90%;
        height: auto;
        margin: 0 auto;
      }
    }
  }
  @media (max-width:350px) {
    #AddToHome .content .case{
      width: 70%;
    }
  }

</style>



// WEBPACK FOOTER //
// AddToHome.vue?3967f050